import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {Provider} from 'react-redux';
import {store} from './Store/Store';
import {ToastContainer} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.min.css';
import {I18nextProvider} from 'react-i18next';
import i18next from 'i18next';
import * as Sentry from '@sentry/react';
import {Integrations} from '@sentry/tracing';
import './Assets/Styles/Master.Style.scss';
import {config} from './Configs';

Sentry.init({
    dsn: config.sentry.reactAppSentryDSN,
    release: `elevatus-administration@${config.sentry.version}`,
    environment: config.sentry.reactAppENV,
    integrations: [new Integrations.BrowserTracing()],
    beforeSend(event) {
    // Check if it is an exception, and if so, show the report dialog
        if (event.exception) {
            Sentry.showReportDialog({eventId: event.event_id});
        }

        return event;
    },

    // We recommend adjusting this value in production, or using tracesSampler
    // for finer control
    tracesSampleRate: 1.0,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <I18nextProvider i18n={i18next}>
        <Provider store={store}>
            <Sentry.ErrorBoundary
                fallback='An error has occurred'
                beforeCapture={(scope) => {
                    scope.setTag('type', 'general-error');
                }}>
                <App />
                <ToastContainer />
            </Sentry.ErrorBoundary>
        </Provider>
    </I18nextProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(console.log);
